module.exports = __webpack_public_path__ + "img/individual.7ad77146.png";